import { Component } from '@angular/core';
import { AdminActionsDirective } from '@app/main/admin/directives/admin-actions.directive';
import { AdminService } from '../../../admin.service';
import { SnackService } from '@shared/services/snack.service';
import { FaqService } from '@shared/services/faq.service';
import { AdminFaqService } from '@app/main/admin/modules/admin-faq/services/admin-faq.service';
import { IFaq } from '@shared/interfaces';
import { MatDialog } from '@angular/material/dialog';
import { DialogService } from '@shared/services';
import { ModuleService } from '@shared/services/module.service';

@Component({
    selector: 'app-admin-toolbar-faq',
    templateUrl: './admin-toolbar-faq.component.html',
    styleUrls: ['./admin-toolbar-faq.component.scss'],
    standalone: false
})
export class AdminToolbarFaqComponent extends AdminActionsDirective {
    constructor(
        private snack: SnackService,
        private faqService: FaqService,
        private adminFaqService: AdminFaqService,
        private dialog: MatDialog,
        adminService: AdminService,
        dialogService: DialogService,
        moduleService: ModuleService
    ) {
        super(adminService, dialogService, moduleService);
    }

    async saveSort() {
        try {
            const result = await this.faqService.saveSort(this.adminFaqService.currentItem);
            this.snack.openSnackBarSuccess('admin.faq.snacks.sortSuccess');
            this.goBackInFaq(this.selectedItem, result);
        } catch (e) {
            console.error(e);
        }
    }

    get item(): IFaq {
        return this.selectedItem;
    }
}
